import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const style = makeStyles()((theme: Theme) => ({
  moduleSpace: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',

    marginTop: '-3.5%',
    paddingTop: '2.5%',
    [theme.breakpoints.down(480)]: {
      marginLeft: '16px',
      marginRight: '16px',
    },
  },
  title: {
    marginBottom: '5%',
    marginLeft: '7.5%',
    alignSelf: 'flex-start',
    color: '#4F5A65',
    fontSize: '57px !important',
    [theme.breakpoints.down(480)]: {
      textAlign: 'left',
      marginLeft: '0%',
    },
    [theme.breakpoints.between(600, 480)]: {
      textAlign: 'left',
      marginLeft: '7.5%',
    },
  },
  outlineContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  outlining: {
    marginTop: '2%',
    width: '85%',
    maxWidth: '764px',
    borderRadius: '8px',
    border: '1px solid #616673',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down(480)]: {
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      marginTop: '7%',
    },
  },
  textView: {
    flex: 0.55,
    marginLeft: '3%',
    [theme.breakpoints.down(480)]: { flex: 'none' },
    [theme.breakpoints.between(480, 520)]: {
      flex: 0.5,
    },
    [theme.breakpoints.between(600, 660)]: {
      flex: 0.5,
    },
  },
  buttonView: {
    flex: 0.45,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(480)]: {
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      margin: '0 6% 6%',
    },
    [theme.breakpoints.between(480, 520)]: {
      flex: 0.5,
    },
    [theme.breakpoints.between(600, 700)]: {
      flex: 0.5,
    },
  },
  headLine: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '20px',
    color: '#2E343B',
    margin: '4% 0% 3%',
    [theme.breakpoints.down(480)]: {
      margin: '4%',
    },
  },
  summaryText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    color: '#1A1A1E',
    marginBottom: '5%',
    [theme.breakpoints.down(480)]: {
      margin: '4%',
    },
  },
}))

export default style
